/**
 * Show an account proxy
 *
 * A proxy comes from account.proxies. 
 * It has a target account and a list of grants
 */
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import item_template from '@/../templates/collaboration-item.hbs';

var globalCh = Radio.channel('global');

var ProxyView = Marionette.View.extend({
    template: Handlebars.compile(item_template),
    tagName: 'tr',
    ui: {
        action_switch: '.action.switch',
        action_resign: '.action.resign',
        roles: '.roles',
    },
    regions: {
        roles_region: '@ui.roles'
    },
    events: {
        'click @ui.action_switch': 'switch_account',
        'click @ui.action_resign': 'revoke_collaboration'
    },
    initialize: function(options) {
        this.active_account = options.active_account;
    },
    templateContext: function() {
        // Each item is a grant, which has a 'grantee' and a 'target'
        // In this context we want to know the 'target' of the grant as well as the role
        var target = this.model.get('target');
        var roles = this.model.get('grants').map(function(g) {
            return g.rel.get('role').get('name');
        }).join(', ');
        var context = {
            username: target && target.get('username') || 'unknown',
            email: target && target.get('email') || 'unknown',
            status: 'Active',
            roles: roles
        };
        return context;
        
    },
    // Need this to allow lazy loading of usernames for collaborators missing info
    modelEvents: {
        'change': 'render'
    },
    onRender: function() {
        this.ui.action_switch.tooltip({
            delay: { show: 500, hide: 100 }
        });
        this.ui.action_resign.tooltip({
            delay: { show: 500, hide: 100 }
        });
    },
    switch_account: function() {
        globalCh.request('changeActiveAccount', this.model.get('target'), function() {
            globalCh.request('home');
        });
    },
    revoke_collaboration: function() {
        globalCh.request('show_resign_from_role_dialog', this.model);
    }
});

export default ProxyView;
